import { Tag } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface InvoiceAmountCellProps {
  amount: ReactNode
  isVoided: boolean
}

export const InvoiceAmountCell = ({ amount, isVoided }: InvoiceAmountCellProps): ReactElement => {
  const { t } = useTranslation()

  if (isVoided) {
    return (
      <Tag color="neutral" type="subtle">
        {t('external_invoices.list.table.voided')}
      </Tag>
    )
  }

  return <>{amount}</>
}
